var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "JadeBox",
        { attrs: { hasPadding: "" } },
        [
          _c("div", { staticClass: "contact-owner__img--container" }, [
            _c("img", {
              attrs: { src: require(`@/assets/kyc/step_0.svg`).default },
            }),
          ]),
          _c(
            "div",
            { staticClass: "contact-owner__text--container" },
            [
              _c(
                "jade-text",
                { attrs: { weight: "bold", variant: "heading-small" } },
                [_vm._v(" " + _vm._s(_vm.$t("title")) + " ")]
              ),
              _c("jade-text", { attrs: { variant: "text-medium" } }, [
                _vm._v(" " + _vm._s(_vm.$t("subtitle")) + " "),
              ]),
            ],
            1
          ),
          _c(
            "jade-button",
            {
              staticClass: "contact-owner__button--container",
              attrs: { size: "medium" },
              on: { click: _vm.redirectToCompany },
            },
            [_vm._v(" " + _vm._s(_vm.$t("button")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }